import { Box, Button, Typography } from '@mui/material';
import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';

import { COLORS } from '../../../configs/colors';

interface MobileSignatureFieldProps {
  title: string;
  isRequired: boolean;
  /** The signature as a PNG data URL, or empty before capture. */
  value?: string;
  onChange: (value: string) => void;
}

export const InteractionSignatureField: React.FC<MobileSignatureFieldProps> = ({
  title,
  isRequired,
  value,
  onChange,
}) => {
  // react-signature-canvas ships no usable instance type; this is the subset of
  // its API this field calls.
  const sigRef = useRef<{ toDataURL: (type?: string) => string; clear: () => void } | null>(null);

  const handleEnd = () => {
    if (sigRef.current) {
      const dataUrl = sigRef.current.toDataURL('image/png');
      onChange(dataUrl);
    }
  };

  const handleClear = () => {
    if (sigRef.current) {
      sigRef.current.clear();
    }
    onChange('');
  };

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
        {title}
        {isRequired && ' *'}
      </Typography>
      <Box
        sx={{
          border: `1px solid ${COLORS.SubtleGrey}`,
          borderRadius: 1,
          overflow: 'hidden',
          touchAction: 'none',
        }}
      >
        <SignatureCanvas
          ref={sigRef}
          canvasProps={{
            width: 320,
            height: 150,
            style: { width: '100%', height: 150 },
          }}
          onEnd={handleEnd}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
        <Button variant="outlined" size="small" onClick={handleClear}>
          Clear
        </Button>
        {value && (
          <Typography variant="caption" color="success.main" sx={{ alignSelf: 'center' }}>
            Signature captured
          </Typography>
        )}
      </Box>
    </Box>
  );
};
